import { founder } from './content'

/**
 * Hoofdnavigatie, gedeeld door header, mobiel menu en footer. Volgorde = het bedrijf:
 * eerst de salon, dan de webshop en de protocollen, daarna verdieping en contact.
 */
export const mainNav = [
  { to: '/behandelingen', label: 'Salon' },
  { to: '/webshop', label: 'Webshop' },
  { to: '/routines', label: 'Protocollen' },
  { to: '/journal', label: 'Journal' },
  {
    to: '/over-ons',
    get label() {
      return `Over ${founder.firstName}`
    },
  },
  { to: '/contact', label: 'Contact' },
]
